import Widget, {
  defaultWidgetNameProps as defaultClaimWidgetNameProps,
  WidgetNameProps as ClaimWidgetNameProps,
  WidgetNameTag as ClaimWidgetNameTag,
  WidgetNameTagType as ClaimWidgetNameTagType,
} from '@/exports/ClaimCompleteWidget';
import ScribeWidget, {
  defaultWidgetNameProps as defaultScribeWidgetNameProps,
  WidgetNameProps as ScribeWidgetNameProps,
  WidgetNameTag as ScribeWidgetNameTag,
  WidgetNameTagType as ScribeWidgetNameTagType,
} from '@/exports/ScribeCompleteWidget';

/**
 * @dev When adding new widgets, add them to the the Widgets object below
 *      and make sure to add the export to the Widgets type. Lastly add
 *      the export to the WidgetsPropsMap type. There is a very clear pattern
 *      to follow here, so please follow it!
 */

export interface WidgetPropsMap {
  [ClaimWidgetNameTag]: ClaimWidgetNameProps;
  [ScribeWidgetNameTag]: ScribeWidgetNameProps;
}

type Widgets = {
  readonly [ClaimWidgetNameTag]: WidgetMetadata<WidgetPropsMap[ClaimWidgetNameTagType]>;
  readonly [ScribeWidgetNameTag]: WidgetMetadata<WidgetPropsMap[ScribeWidgetNameTagType]>;
};

export const Widgets: Widgets = {
  [ClaimWidgetNameTag]: {
    component: Widget,
    defaultProps: defaultClaimWidgetNameProps,
  },
  [ScribeWidgetNameTag]: {
    component: ScribeWidget,
    defaultProps: defaultScribeWidgetNameProps,
  },
} as const;

/**
 * @dev don't touch anything below here when adding new widgets
 */

export type WidgetsKeys = keyof typeof Widgets;

export interface WidgetMetadata<T> {
  component: (props: T) => React.JSX.Element;
  defaultProps: T;
}

export const isRecognisedWidgetName = (widgetName?: string): widgetName is WidgetsKeys => {
  if (!widgetName) {
    return false;
  }

  return !!Widgets[widgetName as WidgetsKeys];
};
